var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: {
      loaded: _vm.loaded
    }
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'contact'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _vm._m(0)], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "pt-16 sm-md:pt-32 contact--section effect--fade-slide-in"
  }, [_c('div', {
    staticClass: "section--container section--container-page"
  }, [_c('div', {
    staticClass: "container max-w-2xl section--content"
  }, [_c('h1', [_vm._v("Legal Documents")]), _vm._v(" "), _c('ul', {
    staticClass: "mt-12 space-y-6 sm-md:space-y-4 sm-md:mt-8"
  }, [_c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/e-sign",
      "target": "blank"
    }
  }, [_vm._v("E-SIGN Act Disclosure and Consent\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/cardholder-agreement"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tCardholder Agreement\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/fcra",
      "target": "blank"
    }
  }, [_vm._v("FCRA Notice")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/lead-loc",
      "target": "blank"
    }
  }, [_vm._v("Lead Bank Overdraft Line of Credit Agreement")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/giveaways",
      "target": "blank"
    }
  }, [_vm._v("Giveaways")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/privacy",
      "target": "blank"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "href": "/legal/terms",
      "target": "blank"
    }
  }, [_vm._v("Terms of Service")])])])])])]);
}];
export { render, staticRenderFns };